import { render, staticRenderFns } from "./SaleTypeEditMailSettings.vue?vue&type=template&id=21c9e00e"
import script from "./SaleTypeEditMailSettings.vue?vue&type=script&lang=ts"
export * from "./SaleTypeEditMailSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports